import React from "react"
// import Img from "gatsby-image"
// import { StaticQuery, graphql } from "gatsby"


// function ImageQueries() {
//   return (
//     <StaticQuery
//       query={graphql`
//         query MyQuery {
//           image1: file(relativePath: { eq: "imageFeaturePlaceholder.png" }) {
//             childImageSharp {
//               fluid (maxWidth: 3080, quality: 100){
//                 aspectRatio
//                 base64
//                 sizes
//                 src
//                 srcSet
//               }
//             }
//           }
//           image2: file(relativePath: { eq: "imageFeatureFireAutomateCommunication.png" }) {
//             childImageSharp {
//               fluid (maxWidth: 452, quality: 100){
//                 aspectRatio
//                 base64
//                 sizes
//                 src
//                 srcSet
//               }
//             }
//           }
//         }
//       `}
//     />
//   )
// }

// function ImageFeaturePlaceholder() {
//   return (
//     <Img
//       fluid={data.image1.childImageSharp.fluid}
//       alt="Placeholder image."
//       className="featureImage"
//     />
//   )
// }

// function ImageFeatureFireAutomateCommunication() {
//   return (
//     <Img
//       fluid={data.image2.childImageSharp.fluid}
//       alt="Placeholder image."
//       className="featureImage"
//     />
//   )
// }

// Law Enforcement

function ImageFeatureLawVideoReportingOfficer() {
  return (
    <img src="/imageFeatureLawVideoReportingOfficer.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '491px', maxHeight: '452px', minWidth: '491px', minHeight: '452px' }}
      />
  )
}

function ImageFeatureLawTextTheChief() {
  return (
    <img src="/imageFeatureLawTextTheChief.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '406px', maxHeight: '540px', minWidth: '406px', minHeight: '540px' }}
      />
  )
}

function ImageFeatureLawTextIncidentStatusUpdates() {
  return (
    <img src="/imageFeatureLawTextIncidentStatusUpdates.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '620px', minWidth: '896px', minHeight: '620px' }}
      />
  )
}

function ImageFeatureLawSMSSatisfactionSurveys() {
  return (
    <img src="/imageFeatureLawSMSSatisfactionSurveys.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '639px', minWidth: '896px', minHeight: '639px' }}
      />
  )
}

function ImageFeatureLawCitizenEngagementAnalytics() {
  return (
    <img src="/imageFeatureLawCitizenEngagementAnalytics.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '600px', minWidth: '896px', minHeight: '600px' }}
      />
  )
}

// EMS

function ImageFeatureEMSTelehealthResponse() {
  return (
    <img src="/imageFeatureEMSTelehealthResponse.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '546px', minWidth: '896px', minHeight: '546px' }}
      />
  )
}

function ImageFeatureEMSTextBasedSurveys() {
  return (
    <img src="/imageFeatureEMSTextBasedSurveys.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '374px', maxHeight: '540px', minWidth: '374px', minHeight: '540px' }}
      />
  )
}

function ImageFeatureEMSActionableAnalytics() {
  return (
    <img src="/imageFeatureEMSActionableAnalytics.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '416px', minWidth: '896px', minHeight: '416px' }}
      />
  )
}

// Fire

function ImageFeatureFireReduceRisk() {
  return (
    <img src="/imageFeatureFireReduceRisk.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '712px', minWidth: '896px', minHeight: '712px' }}
      />
  )
}

function ImageFeatureFireAutomateCommunication() {
  return (
    <img src="/imageFeatureFireAutomateCommunication.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '452px', maxHeight: '369px', minWidth: '452px', minHeight: '369px' }}
      />
  )
}

function ImageFeatureFirePerformanceInsights() {
  return (
    <img src="/imageFeatureFirePerformanceInsights.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '802px', maxHeight: '542px', minWidth: '802px', minHeight: '542px' }}
      />
  )
}

// 911

function ImageFeature911NonEmergencyServices() {
  return (
    <img src="/imageFeature911NonEmergencyServices.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '760px', maxHeight: '554px', minWidth: '760px', minHeight: '554px' }}
      />
  )
}

function ImageFeature911RequestAdditionalInformation() {
  return (
    <img src="/imageFeature911RequestAdditionalInformation.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '552px', maxHeight: '410px', minWidth: '552px', minHeight: '410px' }}
      />
  )
}

function ImageFeature911AutomaticTextStatusUpdates() {
  return (
    <img src="/imageFeature911AutomaticTextStatusUpdates.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '444px', maxHeight: '540px', minWidth: '444px', minHeight: '540px' }}
      />
  )
}

function ImageFeature911CallTakerPerformanceSurvey() {
  return (
    <img src="/imageFeature911CallTakerPerformanceSurvey.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '444px', maxHeight: '540px', minWidth: '444px', minHeight: '540px' }}
      />
  )
}

function ImageFeature911CitizenSatisfactionSurveys() {
  return (
    <img src="/imageFeature911CitizenSatisfactionSurveys.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '472px', maxHeight: '600px', minWidth: '472px', minHeight: '600px' }}
      />
  )
}

function ImageFeature911PositiveCitizenFeedback() {
  return (
    <img src="/imageFeature911PositiveCitizenFeedback.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '800px', minWidth: '896px', minHeight: '800px' }}
      />
  )
}

function ImageLandingCPSS() {
  return (
    <img src="/imageLandingCPSS.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '600px', minWidth: '896px', minHeight: '600px' }}
      />
  )
}

function ImageFeatureLawQR() {
  return (
    <img src="/imageFeatureLawQR.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '296px', maxHeight: '296px', minWidth: '296px', minHeight: '296px' }}
      />
  ) 
}

function ImageFeatureLawFeedbackBoard() {
  return (
    <img src="/imageFeatureLawFeedbackBoard.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '322px', minWidth: '896px', minHeight: '322px' }}
      />
  ) 
}

function ImageFeatureLawStatusUpdates() {
  return (
    <img src="/imageFeatureLawStatusUpdates.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '374px', maxHeight: '540px', minWidth: '374px', minHeight: '540px' }}
      />
  ) 
}

function ImageFeatureLawTasks() {
  return (
    <img src="/imageFeatureLawTasks.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '424px', maxHeight: '526px', minWidth: '424px', minHeight: '526px' }}
      />
  ) 
}

function ImageFeature911CPSS() {
  return (
    <img src="/imageFeature911CPSS.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '896px', maxHeight: '664px', minWidth: '896px', minHeight: '664px' }}
      />
  ) 
}

function ImageFeature911ResponseRate() {
  return (
    <img src="/imageFeature911ResponseRate.png"
      alt="" 
      width="100%" height="auto"
      style={{ maxWidth: '384px', maxHeight: '524px', minWidth: '384px', minHeight: '524px' }}
      />
  ) 
}

export { ImageFeatureLawVideoReportingOfficer, ImageFeatureLawTextTheChief, ImageFeatureLawTextIncidentStatusUpdates, ImageFeatureLawSMSSatisfactionSurveys, ImageFeatureLawCitizenEngagementAnalytics, ImageFeatureEMSTelehealthResponse, ImageFeatureEMSTextBasedSurveys, ImageFeatureEMSActionableAnalytics, ImageFeatureFireReduceRisk, ImageFeatureFireAutomateCommunication, ImageFeatureFirePerformanceInsights, ImageFeature911NonEmergencyServices, ImageFeature911RequestAdditionalInformation, ImageFeature911AutomaticTextStatusUpdates, ImageFeature911CallTakerPerformanceSurvey, ImageFeature911CitizenSatisfactionSurveys, ImageFeature911PositiveCitizenFeedback, ImageLandingCPSS, ImageFeatureLawQR, ImageFeatureLawFeedbackBoard, ImageFeatureLawStatusUpdates, ImageFeatureLawTasks, ImageFeature911CPSS, ImageFeature911ResponseRate }